module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAS0lEQVQoFZXBsRHAQAyAMNh/aIfCtXMvySN5JI9kTTgYImvCwRD5MSGGyI8JMUTWhIMhsiYcDJE1IYaDrAkxHGRNOBgia8LBEHn0AXYIKA/hNxNtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_02.png
// module id = 224
// module chunks = 0